import { EmployeeRolesEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";

export class UnitIdRequest {
    @ApiProperty()
    unitId: number;
    @ApiProperty()
    @IsOptional()
    role?: EmployeeRolesEnum;
    @ApiProperty()
    @IsOptional()
    itemCategoryId?: number;
}